module.exports = __webpack_public_path__ + "img/postit.15b0add8.png";